<template>
  <div>
    <AINewBasic></AINewBasic>
    <div class="home">
      <div class="home__item" v-for="item in (this.$store.state.ai.aiList || [])" :key="item.id" @click="goChat(item)">
        <div class="home__item__image">
          <el-image :src="item.headImg" style="width: 100%; height: 100%;"/>
        </div>
        <div class="home__item__p">{{item.aiName}}</div>
        <!-- <div class="home__item__p">
          <div style="font-size: 16px; font-weight: 800;">{{item.aiName}}</div>
          <div style="font-size: 12px; margin-top: 10px;">{{item.aiDesc}}</div>
        </div> -->
        <div v-if="userId == item.userId" class="home__item__more" @click.stop="showOperateMethod(item.id)">
          <HomeMoreOperate v-if="item.showOperate" :aiId="item.id" :userId="item.userId" :aiName="item.aiName"></HomeMoreOperate>
          <div class="home__item__more__in"><i id="el-icon-more" class="el-icon-more"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import AINewBasic from '../components/AI-New-Basic.vue'
  import HomeMoreOperate from '../components/home/Home-More-Operate.vue'
  export default {
    name: 'Home',
    components: {
      AINewBasic,
      HomeMoreOperate
    },
    data() {
      return {
        userId: localStorage.getItem('userId'),
        aiList: this.$store.state.ai.aiList,
      };
    },
    methods: {
      goChat(aiInfo) {
        this.$router.push({
        path: '/chat',
        query: { aiInfo }
        })
      },
      showOperateMethod(aiId) {
        this.$store.state.ai.aiList.map(item=>{if (item.id === aiId) item.showOperate = !item.showOperate})
      }
    },
    mounted(){
      this.$store.dispatch('getAllList')
    },
}
</script>
<style lang="less" scoped>
  .home{
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    top: 60px;
    left: 220px;
    right: 30px;
    &__item{
      position: relative;
      width: 200px;
      height: 200px;
      margin: 50px 0 0 80px; /*上右下左*/
      cursor: pointer;
      border: 1px solid #3011e1;
      &:hover{
        border-color: #3116cc;
      }
      &__image{
        width: 140px; 
        height: 140px;
        text-align: center;
        margin: 20px auto;
        margin-bottom: 10px;
      }
      &__p{
        font-size: 16px; 
        font-weight: 700;
        text-align: center;
        color: #8C8C8C;
      }
      &__more{
        position: absolute;
        top: 0px;
        right: 0px;
        &__in{
          min-width: 30px;
          min-height: 30px;
          text-align: center;
        }
        :hover{
          background-color: #f4f4f4;
        }
      }
    }
  }
  #el-icon-more{
    margin-top: 12px;
    font-size: 14px; 
    font-weight: 400;
    transform: rotate(90deg)
  }
</style>